import { AxiosError } from 'axios';

import { ErrorMessage, HttpStatusText } from './http-errors';

type PlainObject<T = any> = Record<string, T>;

interface RequestError extends Error {
  detail?: string;
  userMessage?: string;
  response?: PlainObject;
  status?: number;
}

export async function errorInterceptor(error: AxiosError<any>) {
  const { response } = error;
  const code = response?.status ?? HttpStatusText[error.code as keyof typeof HttpStatusText];
  const detail = response?.data?.detail || response?.data?.userMessage || ErrorMessage.DEFAULT;
  const userMessage =
    ErrorMessage[response?.data?.userMessage || response?.data?.detail] ?? ErrorMessage.DEFAULT;

  const failure: RequestError = new Error(userMessage ?? detail ?? ErrorMessage.DEFAULT);
  failure.detail = detail;
  failure.response = { ...response, code: error.code };
  failure.userMessage = userMessage;
  failure.status = code;

  throw failure;
}
